/**
 * @typedef {Object} BookingConfirmationViewModelType
 * @property {number} id - Unique identifier
 * @property {string} name - The name of the confirmation contact
 * @property {string} email - The confirmation contact's email address
 * @property {BookingConfirmationPhoneViewModel} sms - The phone details for sms confirmations
 * @property {BookingConfirmationPhoneViewModel} voice - The phone details for voice confirmations
 */

/**
 * @class
 */
export default class BookingConfirmationViewModel {
  /**
   * Create a new BookingConfirmationViewModel.
   * @param {...BookingConfirmationVewModelType} params
   */
  constructor(params) {
    this.id = params.id
    this.name = params.name
    this.email = params.email
    this.sms = params.sms ? params.sms : null
    this.voice = params.voice ? params.voice : null
  }
}
